import { QueryFunction } from "@tanstack/react-query";
import axios, { isAxiosError } from "axios";
import { useDebugValue } from "react";
import { type QueryKey } from "@tanstack/react-query";

export function useUserVoting(votingApplication: number, voteItem: string, email: string) {
    useDebugValue(votingApplication, va => `Voting App: ${va}`);
    useDebugValue(voteItem, vi => `Vote item: ${vi}`);

    return { voteFunction: voteFn, queryKey: ["vote", votingApplication, voteItem, email] as QueryKey };
}

const voteFn: QueryFunction = async (context) => {
    const { signal } = context;

    const votingApp = context.queryKey[1] as number;
    const voteItem = context.queryKey[2] as string;
    const email = context.queryKey[3] as string;

    const axiosResponse = await axios.request({
        method: "POST",
        url: process.env.NEXT_PUBLIC_VOTE_ENDPOINT,
        data: {
            app: votingApp,
            email: email,
            item: voteItem
        },
        signal
    });
    if (isAxiosError(axiosResponse)) {
        throw axiosResponse;
    }
    return axiosResponse.data;
}